import * as PropTypes from 'prop-types';
import * as React from 'react';
import NestingChild from './NestingChild';
import NestingContext from './NestingContext';
import NestingRoot from './NestingRoot';

var NestingAuto = function NestingAuto(props) {
  return React.createElement(NestingContext.Consumer, null, function (contextValue) {
    var hasContext = !!contextValue;
    var Component = hasContext ? NestingChild : NestingRoot;
    return React.createElement(Component, props);
  });
};

NestingAuto.displayName = 'NestingAuto';
NestingAuto.propTypes = {
  children: PropTypes.func.isRequired
};
export default NestingAuto;